import React from "react";
import {
  CheckboxWrapper,
  HiddenCheckbox,
  StyledCheckbox,
  CheckIcon,
  Content,
  LabelRow,
  Description,
  InfoIcon
} from "components/Checkbox/styled";

const Checkbox = ({
  checked = false,
  size = "M",
  label = "Checkbox",
  description,
  rightIcon = false,
  color = "neutral",
  disabled = false,
  onChange
}) => {
  return (
    <CheckboxWrapper disabled={disabled} description={description}>
      <HiddenCheckbox
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          if (disabled) return;
          onChange?.(e.target.checked);
        }}
      />

      <StyledCheckbox
        checked={checked}
        size={size}
        colorType={color}
        disabled={disabled}
      >
        {checked && (
          <CheckIcon size={size} viewBox="0 0 12 12">
            <path
              d="M1 5L4.5 8.5L11 1"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </CheckIcon>
        )}
      </StyledCheckbox>

      <Content>
        <LabelRow size={size} checked={checked}>
          {label}
          {rightIcon && <InfoIcon>{rightIcon}</InfoIcon>}
        </LabelRow>

        {description && <Description>{description}</Description>}
      </Content>
    </CheckboxWrapper>
  );
};

export default Checkbox;
